<template>
  <div id="questionnaire-area" class="horizontalArea">
    <a v-for="(button, key) in buttons" :key="key" target="_blank" :href="button.url" class="btn" :class="{hard: button.isActive}">
      <template v-if="button.isActive">
        アンケートにご回答ください<br />
        {{ button.description }}
      </template>
      <template v-else>アンケート回答済み</template>
    </a>
  </div>
</template>

<script>
export default {
  name: "QuestionnaireStartButtons",
  props: {
    buttons: {
      type: Array,
      required: true
    }
  }
}
</script>
